import React from 'react';
import { formatCurrency } from '../../utils/currencyFormatter';

const DeletedBucketAnalysis = ({ bucketStats, currency }) => {
    const totalDeleted = bucketStats?.deletedBuckets?.total || 0;
    const totalBuckets = bucketStats?.totalBuckets || 1; // Prevent division by zero
    const deletedPercentage = ((totalDeleted / totalBuckets) * 100).toFixed(0);

    return (
        <div className="bg-white border border-[#6D9773]/20 rounded-lg shadow-sm p-6 text-[#0C3B2E] h-full">
            <h3 className="text-lg font-medium text-[#6D9773] mb-4">Deleted Buckets Analysis</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div>
                    <p className="text-sm font-medium text-gray-600">Total Deleted</p>
                    <p className="text-2xl font-semibold">{totalDeleted}</p>
                    <p className="text-xs text-gray-500">{deletedPercentage}% of all buckets</p>
                </div>
                <div>
                    <p className="text-sm font-medium text-gray-600">Last 30 Days</p>
                    <p className="text-2xl font-semibold">{bucketStats?.deletedBuckets?.recent || 0}</p>
                    <p className="text-xs text-gray-500">Recently deleted buckets</p>
                </div>
                <div>
                    <p className="text-sm font-medium text-gray-600">Lost Revenue</p>
                    <p className="text-2xl font-semibold">
                        {formatCurrency(bucketStats?.deletedBuckets?.lostRevenue || 0, currency)}
                    </p>
                    <p className="text-xs text-gray-500">From deleted buckets</p>
                </div>
                <div>
                    <p className="text-sm font-medium text-gray-600">Average Size</p>
                    <p className="text-2xl font-semibold">{bucketStats?.deletedBuckets?.averageSize || 0}</p>
                    <p className="text-xs text-gray-500">Images per deleted bucket</p>
                </div>
            </div>
        </div>
    );
};

export default DeletedBucketAnalysis;